import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-new-catalog',
  templateUrl: './catalogs-new-catalog.component.html',
  styleUrls: ['./catalogs-new-catalog.component.scss']
})
export class CatalogsNewCatalogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
